import { CollapsedTrainItem } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/CollapsedTrainItem";
import { ExpandableBodyContent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/ExpandableBodyContent";
import { ExpandableHeaderContent } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/ActionableTrainGridItem/ExpandableHeaderContent";
import { Expandable } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/components/ActionableTrains/Expandable";
import { AltTransIncidentTrain } from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { FC } from "react";

type ActionableTrainGridItemProps = {
  actionableTrain: AltTransIncidentTrain;
  collapsed: boolean;
};

export const ActionableTrainGridItem: FC<ActionableTrainGridItemProps> = ({
  actionableTrain,
  collapsed,
}) =>
  collapsed ? (
    <CollapsedTrainItem actionableTrain={actionableTrain} />
  ) : (
    <Expandable
      asSubgrid
      headerContent={
        <ExpandableHeaderContent actionableTrain={actionableTrain} />
      }
    >
      <ExpandableBodyContent actionableTrain={actionableTrain} />
    </Expandable>
  );
